import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import { storage } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { CART_FALLBACK, CART_ID } from '../constants'

const db = storage('local')

const restoreCart = () => {
  const localSCartId = db.getItem(CART_ID)
  const localFCartId = getCSRCookieData(CART_FALLBACK)

  if (!localSCartId && localFCartId) {
    db.setItem(CART_ID, localFCartId)
  }
}

export default restoreCart
